module.exports = __webpack_public_path__ + "img/undraw_unexpected_friends.5723e523.svg";